import { render, staticRenderFns } from "./CodeGenerator.vue?vue&type=template&id=39b1b0be&"
import script from "./CodeGenerator.vue?vue&type=script&lang=js&"
export * from "./CodeGenerator.vue?vue&type=script&lang=js&"
import style0 from "./CodeGenerator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports